angular.module('cimerFrontEndApp').controller('CuratedQuestionsModalCtrl', ['$scope', '$uibModalInstance', 'curatedQuestions', 'tags', function ($scope, $uibModalInstance, curatedQuestions, tags) {
    "use strict";

    $scope.curatedQuestions = curatedQuestions;
    $scope.allCuratedQuestions = curatedQuestions;
    $scope.tags = tags;

    $scope.filterTags = [];
    $scope.tagDropdownSettings = {
        externalIdProp: '',
        idProp: 'TagId',
        displayProp: 'Name',
        showCheckAll: false,
        smartButtonMaxItems: 3,
        template: '<span ng-attr-title="{{option.Name}}">{{option.Name}}</span>',
        buttonClasses: 'btn btn-default'
    };
    $scope.tagFilterEvents = {
        onSelectionChanged: function () {
            $scope.filterQuestionGroups();
        }
    };

    $scope.addCuratedQuestionGroup = function (sectionID) {
        $uibModalInstance.close(sectionID);
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.filterQuestionGroups = function () {
        if (!$scope.filterTags) {
            $scope.curatedQuestions = $scope.allCuratedQuestions;
            return;
        }
        $scope.curatedQuestions = []; // clear the display list
        var currentFilteredQuestionList = $scope.allCuratedQuestions;  // start this with all the questions
        var tagFilteredList = [];
        if ($scope.filterTags && $scope.filterTags.length > 0) {
            for (var j = 0; j < currentFilteredQuestionList.length; j++) {
                var question = currentFilteredQuestionList[j];
                var addQuestion = true;
                for (var l = 0; l < $scope.filterTags.length; l++) {
                    var foundTag = false;
                    for (var k = 0; k < question.Tags.length; k++) {
                        if (question.Tags[k].TagId === $scope.filterTags[l].TagId) {
                            foundTag = true;    // we need to find all the tags in the filter list on this question to be able to add it
                            break;
                        }
                    }
                    if (!foundTag) {  // we didn't find the filter tag, move to the next question
                        addQuestion = false;
                        break;
                    }
                }
                if (addQuestion) {
                    tagFilteredList.push(question);
                }
            }
            currentFilteredQuestionList = tagFilteredList; // we've filtered this list, assign it to the current question list
        }
        $scope.curatedQuestions = currentFilteredQuestionList;
    };
}]);